export const FLAG_GETTING_TRIP_REQUESTS = 'FLAG_GETTING_TRIP_REQUESTS';
export const GET_TRIP_REQUESTS = 'GET_TRIP_REQUESTS';
export const CLEAR_TRIP_REQUESTS = 'CLEAR_TRIP_REQUESTS';
export const FLAG_TRIP_REQUEST_ACTIVITY = 'FLAG_TRIP_REQUEST_ACTIVITY';
export const GET_TRIP_REQUEST = 'GET_TRIP_REQUEST';
export const CLEAR_TRIP_REQUEST = 'CLEAR_TRIP_REQUEST';
